import { usePage } from "@inertiajs/react";
import { useCallback } from "react";
import { useSystemAlertStore } from "@/stores/system-alert-store";
import type { SharedData } from "@/types";

export function useSystemAlert() {
  const { systemAlert } = usePage<SharedData>().props;
  const dismissedAlertIds = useSystemAlertStore(
    (state) => state.dismissedAlertIds
  );
  const dismissAlert = useSystemAlertStore((state) => state.dismissAlert);

  const alertId = systemAlert?.is_dismissable ? systemAlert.id : undefined;

  const isDismissed = alertId ? dismissedAlertIds.includes(alertId) : false;

  const dismiss = useCallback(() => {
    if (alertId) {
      dismissAlert(alertId);
    }
  }, [alertId, dismissAlert]);

  const isVisible = Boolean(systemAlert) && !isDismissed;

  return {
    systemAlert,
    isDismissed,
    isVisible,
    dismiss,
  };
}
